import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/article/:id',
        name: 'detail',
        component: () => import('../views/detail.vue'),
        props: true
    },
    {
        path: '/site',
        name: 'site',
        component: () => import('../views/site.vue'),
        props: true
    }
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});

export default router;
